module.exports = require('./helpers/bundle-url').getBundleURL('5D0wD') + "1F60A.8a356ca2.svg";